import type { PanelIntro as PanelIntroCopy } from "./panelIntros";

type Props = { intro: PanelIntroCopy };

/** Short plain-language explainer at the top of a Program News tab. */
const PanelIntro = ({ intro }: Props) => (
  <div className="rounded-md border bg-muted/30 px-4 py-3 text-sm" data-testid="panel-intro">
    <div className="font-medium">{intro.title}</div>
    {intro.paragraphs.map(text => (
      <p key={text} className="mt-1 text-muted-foreground">
        {text}
      </p>
    ))}
  </div>
);

export default PanelIntro;
